
<br>
<div class="container" *ngIf="survey" hidden>
    <form autocomplete="off">
        <div class="row div-title">
            <div class="col-12 text-center">
                <h3>Vista Previa</h3>
                <hr>
            </div>
            <div class="col-sm-3 text-center">
                <img class="img-fluid logo-survey" src="/assets/img/logo.png" alt="">
            </div>
            <div class="col-sm-9" style="position: relative;">
                <div class="input-title">
                    {{survey.title}}
                </div>
            </div>
            <br>
        </div>
        <div class="row">
            <div class="col-12">
                <ng-container *ngIf="survey">
                    <ng-container *ngFor="let s of survey.sections">
                        <div class="col-12 div-section">
                            <h3>{{s.title}}</h3>
                            <p [innerHTML]="s.summary"></p>
                            <p [innerHTML]="s.detail"></p>
                            <ng-container *ngFor="let q of s.questions">
                                <div class="div-question">
                                    <h5>{{q.label}}</h5>
                                    <p>{{q.summary}}</p>
                                    <ng-container *ngIf="q.idquestiontype === 1">
                                        <div class="row div-options">
                                            <ng-container *ngFor="let o of q.options">
                                                <div class="col-sm-3 form-group">
                                                    <div class="form-check">
                                                        <input class="form-check-input radio" type="radio"
                                                            name="flexRadioDefault" id="{{o.id}}">
                                                        <label class="form-check-label radio-label" for="{{o.id}}">
                                                            {{o.label}}
                                                        </label>
                                                    </div>

                                                </div>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="q.idquestiontype === 9">
                                        <div class="row div-options">
                                            <ng-container *ngFor="let o of q.options">
                                                <div class="col-sm-6 form-group">
                                                    <ng-container *ngIf="o.label.length > 0">
                                                        <label class="form-label" for="{{o.id}}">
                                                            {{o.label}}
                                                        </label>
                                                    </ng-container>
                                                    <input class="form-control" type="text" name="flexRadioDefault"
                                                        id="{{o.id}}">
                                                </div>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="q.idquestiontype === 11">
                                        <div class="row div-options">
                                            <ng-container *ngFor="let o of q.options">
                                                <div class="col-sm-12 form-group">
                                                    <label class="form-label" for="{{o.id}}">
                                                        {{o.label}}
                                                    </label>
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col"></th>
                                                                <ng-container *ngFor="let a of o.axis">
                                                                    <ng-container *ngIf="a.type === 2">
                                                                        <th class="text-center" scope="col">{{a.label}}
                                                                        </th>
                                                                    </ng-container>
                                                                </ng-container>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <ng-container *ngFor="let a of o.axis">
                                                                <ng-container *ngIf="a.type === 1">
                                                                    <tr>
                                                                        <th scope="row">{{a.label}}</th>
                                                                        <ng-container *ngFor="let b of o.axis">
                                                                            <ng-container *ngIf="b.type === 2">
                                                                                <td class="text-center">
                                                                                    <input class="radio" type="radio"
                                                                                        name="radio+{{a.id}}"
                                                                                        id="{{o.id+'-'+b.id}}">
                                                                                </td>
                                                                            </ng-container>
                                                                        </ng-container>
                                                                    </tr>
                                                                </ng-container>

                                                            </ng-container>
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="q.idquestiontype === 13">
                                        <div class="row div-options">
                                            <div class="col-sm-6 form-group">
                                                <select class="form-control form-input"
                                                    aria-label=".form-select-lg example">
                                                    <option selected>Seleccione una opción</option>
                                                    <ng-container *ngFor="let o of q.options">
                                                            <option value="{{o.id}}">{{o.label}}</option>
                                                    </ng-container>                                                    
                                                </select>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <div></div>
                </ng-container>
            </div>
        </div>
    </form>
</div>